var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          ref: "popoverTarget",
          staticClass: "tooltip-target no-outline",
          attrs: { tabindex: "-1" },
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          ref: "popover",
          attrs: {
            target: _vm.getPopoverTarget,
            triggers: "hover",
            placement: "right",
            boundary: "viewport",
            "custom-class": "inline-followup",
          },
          on: { hide: _vm.handlePopoverClose },
        },
        [
          _c(
            "div",
            {
              staticClass: "container px-3 followup-popover-menu",
              attrs: { id: "reminders-popover" },
            },
            [
              _vm.noReminders
                ? _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col p-4" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("boards.messages.noActivitiesScheduled")
                          ) +
                          "\n        "
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.classificationOrder, function (classification) {
                return _c("div", { key: classification }, [
                  _c(
                    "div",
                    { staticClass: "row mb-2 py-1 sticky-top bg-white" },
                    [
                      _c("div", { staticClass: "col" }, [
                        _c("b", [
                          _vm._v(
                            _vm._s(_vm.getClassificationTitle(classification)) +
                              " (" +
                              _vm._s(
                                _vm.remindersByClassification[classification]
                                  .length
                              ) +
                              ")"
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c(
                        "ul",
                        { staticClass: "pl-0 followup-list" },
                        _vm._l(
                          _vm.remindersByClassification[classification],
                          function (reminder) {
                            return _c(
                              "reminder-item",
                              _vm._b(
                                {
                                  key: reminder.id,
                                  ref: "reminderItems",
                                  refInFor: true,
                                  attrs: { classification: classification },
                                  on: {
                                    "reminder-complete":
                                      _vm.handleReminderComplete,
                                    change: _vm.handleChange,
                                  },
                                },
                                "reminder-item",
                                Object.assign({}, reminder),
                                false
                              )
                            )
                          }
                        ),
                        1
                      ),
                    ]),
                  ]),
                ])
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row border-top sticky-bottom bg-white" },
                [
                  _c("div", { staticClass: "col py-1" }, [
                    _c(
                      "a",
                      {
                        directives: [
                          { name: "close-popover", rawName: "v-close-popover" },
                        ],
                        staticClass: "clickable text-primary create-followup",
                        on: { click: _vm.handleNewReminder },
                      },
                      [
                        _vm._v(
                          "+ " +
                            _vm._s(_vm.$t("boards.actions.scheduleAnActivity"))
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }